<!-- eslint-disable import/no-cycle -->
<template>
  <section>
    <h1>QrCode</h1>
    <b-card>
      <b-row style="text-align: center;">
        <b-col>
          <img
            id="base64"
            alt="Leia o QRCODE"
            src="https://icon-library.com/images/qr-code-icon/qr-code-icon-4.jpg"
          >
        </b-col>
        <b-col>
          <br>
          <div>
            <h3 style="margin-bottom: 2px;">
              ManyConvert Zap
            </h3>
            <h3 style="margin-bottom: 2px;">
              Notificações <i class="bell" />
            </h3>
          </div>
          <br>
          <div>
            <h5>
              Use o Whatsapp do ceu celular para ler o QrCode.
            </h5>
          </div>
          <br>
          <b-button
            id="getQrCode"
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="reset"
            variant="success"
            @click="getQrCode()"
          >
            Clique Aqui para Gerar o QrCode
          </b-button>
        </b-col>
      </b-row>
    </b-card>
  </section>
</template>

<script>
import {
  BCard, BRow, BCol, BButton,
} from 'bootstrap-vue'

import qrcode from './qrcode'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
  },
  data() {
    return {
      qrcode,
    }
  },
  methods: {
    async getQrCode() {
      const { session } = this.$route.params

      document.getElementById('getQrCode').disabled = true

      const instance = await qrcode.getInstance(session)

      setInterval(() => {
        qrcode.report(session).then(async resp => {
          if (resp.qrcode.value) {
            document.getElementById('base64').src = resp.qrcode.value
          } else if (resp.connected === true) {
            console.log('já esta conectado!')
            await this.$swal({
              title: 'Conectado!',
              text: 'Apartir de agora seu whatsapp irá começar a enviar as notificações.',
              icon: 'success',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            })
            window.location.href = 'http://beta.manyconvert.com'
          }
        }).catch(async () => {
          document.getElementById('getQrCode').disabled = false
          await this.$swal({
            title: 'Algo deu errado!',
            text: 'Não foi possivel conectar seu whatsapp, por favor, entre em contato com o suporte.',
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          })
          document.getElementById('getQrCode').disabled = false
        })
      }, 3000)
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
